import React from "react";
import { CheckCircle, Warning, XCircle } from "@phosphor-icons/react";

// Multi-modal indicator: color + icon + shape + text. Never rely on color alone.
export default function ResultBadge({ outcome, size = "lg" }) {
    const map = {
        green: {
            label: "VALID",
            Icon: CheckCircle,
            bg: "bg-green-600",
            text: "text-white",
            border: "border-green-800",
        },
        amber: {
            label: "CAUTION",
            Icon: Warning,
            bg: "bg-amber-500",
            text: "text-black",
            border: "border-amber-700",
        },
        red: {
            label: "INVALID",
            Icon: XCircle,
            bg: "bg-primary",
            text: "text-primary-foreground",
            border: "border-red-900",
        },
    };
    const cfg = map[outcome] || map.red;
    const Icon = cfg.Icon;
    const s = size === "lg" ? "p-8 text-3xl" : "p-3 text-sm";
    return (
        <div
            className={`flex flex-col items-center justify-center gap-3 rounded-lg border-2 ${cfg.bg} ${cfg.text} ${cfg.border} ${s}`}
            data-testid={`result-${outcome}`}
            role="status"
            aria-live="polite"
        >
            <Icon size={size === "lg" ? 96 : 24} weight="fill" />
            <div className="font-black tracking-[0.3em] uppercase">{cfg.label}</div>
        </div>
    );
}
